import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Typography } from '@altermaind/web/ui';
import { ClaimsComponent } from '@/_shared/components/Claims';
import { LayoutContext } from '@/_shared/components/PageLayout';
import { Roles } from '@/_shared/constants/roles';
import { Sections, Tutorial } from '../components';

export const TrainingHardSkillsScreen = () => {
  const t = useTranslations('trainingHardSkills');
  const { setLayout } = useContext(LayoutContext);

  useEffect(() => {
    setLayout({ title: 'trainingHardSkills' });
  }, [setLayout, t]);

  return (
    <>
      <ClaimsComponent roles={[Roles.Admin, Roles.HR_Delegate]}>
        <>
          <Typography variant='h1' mb='xs'>
            {t('trainingHardSkillsTitleAdmin')}
          </Typography>
          <Typography variant='p2/light' color='grey/light' mb='m'>
            {t('description')}
          </Typography>
          <Tutorial.Admin />
        </>
      </ClaimsComponent>
      <ClaimsComponent roles={[Roles.Employee, Roles.Manager]}>
        <>
          <Typography variant='h1' mb='m'>
            {t('trainingHardSkillsTitleEmployee')}
          </Typography>
          <Sections.NewContents />
          <Sections.MyContents />
          <Tutorial.Learning />
        </>
      </ClaimsComponent>
      <Sections.MainContents />
    </>
  );
};
